import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import apiRoutes from '../../../app/api/routes';

export const VEHICLE_RESOURCE = 'vehicle';

export default ComposedComponent =>
  compose(
    withTranslation(),
    reduxFetch(() => [
      {
        resource: VEHICLE_RESOURCE,
        method: 'get',
        request: vehicleId => ({
          url: apiRoutes.vehicle(vehicleId),
          clearValueOnRequest: true,
        }),
      },
    ])
  )(props => <ComposedComponent {...props} />);
